module.exports = __webpack_public_path__ + "static/media/sup.0de2e6d3.jpg";